import { PlanningItineraryApp } from "itineraryexport/PlanningItineraryApp";
import { PlanningMapApp } from "Planning/PlanningMapApp";
import { PlanningMonthApp } from "Planning/PlanningMonthApp";
import { PlanningQuarterApp } from "Planning/PlanningQuarterApp";
import { PlanningWeekApp } from "Planning/PlanningWeekApp";
import { type RouteObject } from "react-router";

declare let viewModel: any;

export const planningRoute: RouteObject = {
  path: "planning",
  children: [{
    path: "month",
    loader: () => viewModel,
    Component: PlanningMonthApp,
  }, {
    path: "quarter",
    loader: () => viewModel,
    Component: PlanningQuarterApp,
  }, {
    path: "week",
    loader: () => viewModel,
    Component: PlanningWeekApp,
  }, {
    path: "map",
    loader: () => viewModel,
    Component: PlanningMapApp,
  }, {
    path: "itinerary",
    loader: () => viewModel,
    Component: PlanningItineraryApp,
  }]
};